import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import { GC_USER_ID } from '@/constants'
import { groupQuery } from '@/graphql/queries/group'
import {
  newGroup,
  updateGroup,
  removeFromTrackersOnGroup,
  deleteGroup
} from '@/graphql/mutations/group'
import DeleteModal from '../modals/Delete'

import * as moment from 'moment'
import momenttz from 'moment-timezone'
import {
  Modal,
  Typography,
  Paper,
  GridList,
  GridListTile,
  Checkbox,
  Button
} from 'material-ui'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import Select from 'material-ui/Select'
import { MenuItem } from 'material-ui/Menu'
import { InputLabel } from 'material-ui/Input'
import { FormControl, FormGroup, FormControlLabel } from 'material-ui/Form'
import RemoveIcon from 'material-ui-icons/Remove'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import TimelapseIcon from 'material-ui-icons/Timelapse'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import StarIcon from 'material-ui-icons/Star'
import StarBorderIcon from 'material-ui-icons/StarBorder'
import AlarmOnIcon from 'material-ui-icons/AlarmOn'
import DateRangeIcon from 'material-ui-icons/DateRange'
import Loading from './Loading'
import TrackersModal from './Trackers'

@graphql(newGroup, {
  name: 'newGroup',
  options: {
    refetchQueries: ['routinesQuery', 'groupsQuery', 'groupQuery']
  }
})
@graphql(updateGroup, {
  name: 'updateGroup',
  options: {
    refetchQueries: ['routinesQuery', 'groupsQuery', 'groupQuery']
  }
})
@graphql(groupQuery, {
  name: 'groupQuery',
  options: ownProps => ({
    variables: {
      id: ownProps.id
    },
    refetchQueries: ['groupsQuery']
  })
})
@graphql(deleteGroup, {
  name: 'deleteGroup',
  options: {
    refetchQueries: ['routinesQuery', 'groupsQuery']
  }
})
@graphql(removeFromTrackersOnGroup, {
  name: 'removeFromTrackersOnGroup',
  options: {
    refetchQueries: ['groupQuery']
  }
})
export default class GroupEditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      OpenTrackers: false,
      group: '',

      loadingDel: false,
      OpenDelete: false,

      loading: false,
      loadingSave: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }
    if (nextProps.action !== this.props.action) {
      if (nextProps.action.includes('add')) {
        var r = {
          name: '',
          startedAt: moment().format(),
          completedAt: moment().format(),
          minutesTotal: 0,
          isStared: false,
          isDuration: true,
          isPublic: false,
          isCompleted: false,
          color: '',
          type: 'recur',
          trackers: []
        }
        this.setState({ group: r })
      }
    }

    if (nextProps.groupQuery !== this.props.groupQuery) {
      if (nextProps.groupQuery.Group) {
        this.setState({ group: nextProps.groupQuery.Group })
      }
    }
  }

  handleSave = () => {
    this.setState({ loadingSave: true })
    if (this.props.action.includes('add')) {
      this.props
        .newGroup({
          variables: {
            name: this.state.group.name,
            startedAt: this.state.group.startedAt,
            completedAt: this.state.group.completedAt,
            minutesTotal: this.state.group.minutesTotal,
            isStared: this.state.group.isStared,
            isDuration: this.state.group.isDuration,
            isPublic: this.state.group.isPublic,
            isCompleted: this.state.group.isCompleted,
            color: this.state.group.color,
            type: this.state.group.type,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false,
            loadingSave: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false,
            loadingSave: false
          })
        })
    } else if (this.props.action === 'edit') {
      this.props
        .updateGroup({
          variables: {
            name: this.state.group.name,
            startedAt: this.state.group.startedAt,
            completedAt: this.state.group.completedAt,
            minutesTotal: this.state.group.minutesTotal,
            isStared: this.state.group.isStared,
            isDuration: this.state.group.isDuration,
            isPublic: this.state.group.isPublic,
            isCompleted: this.state.group.isCompleted,
            color: this.state.group.color,
            type: this.state.group.type,
            id: this.state.group.id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false,
            loadingSave: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false,
            loadingSave: false
          })
        })
    }
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleOpenTrackers = () => {
    this.setState({
      OpenTrackers: true
    })
  }

  handleCloseTrackers = () => {
    this.setState({
      OpenTrackers: false
    })
  }

  handleChange = name => event => {
    var newGroup = Object.assign({}, this.state.group)
    switch (name) {
      case 'completedAt':
      case 'startedAt':
        newGroup[name] = momenttz
          .tz(event.target.value, 'America/Los_Angeles')
          .format()
        var s = moment(new Date(newGroup.startedAt))
        var e = moment(new Date(newGroup.completedAt))
        if (s.isSameOrBefore(e)) {
          newGroup.minutesTotal = e.diff(s, 'minutes')
        } else {
          newGroup.minutesTotal = 0
        }
        break
      case 'minutesTotal':
        newGroup[name] = parseInt(event.target.value, 10)
        break
      case 'isPublic':
      case 'isDuration':
      case 'isStared':
        newGroup[name] = !this.state.group[name]
        break
      default:
        newGroup[name] = event.target.value
        break
    }
    this.setState({ group: newGroup })
  }

  handleRemove = id => {
    this.setState({ loading: true })
    this.props
      .removeFromTrackersOnGroup({
        variables: {
          groupsGroupId: this.state.group.id,
          trackersTrackerId: id
        }
      })
      .then(() => {
        this.setState({
          loading: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({
          loading: false
        })
      })
  }

  handleOpenDelete = () => {
    this.setState({
      OpenDelete: true
    })
  }

  handleCloseDelete = () => {
    this.setState({
      OpenDelete: false
    })
  }

  handleDelete = id => {
    this.setState({ loadingDel: true })
    this.props
      .deleteGroup({
        variables: {
          id: id
        }
      })
      .then(() => {
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false
        })
      })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddToday" style={{ borderRadius: 16 }}>
            {this.props.groupQuery.loading ? (
              <Loading />
            ) : (
              <div id="GetUpTime" className="divAddTpday">
                <div className="divClearButton">
                  <IconButton
                    className="btn btn-default btn-style"
                    onClick={this.handleClose}
                  >
                    <ClearIcon className="iconClear" />
                  </IconButton>
                </div>
                <List>
                  <ListItem className="listItemSleepTimeComplete">
                    {this.state.group.type !== 'one' && (
                      <TextField
                        id="name"
                        label="Group Name"
                        className="textFieldLong"
                        value={this.state.group.name}
                        onChange={this.handleChange('name')}
                        InputLabelProps={{
                          className: 'textFieldTimeTiny'
                        }}
                        inputProps={{
                          className: 'textFieldTimeSmall'
                        }}
                      />
                    )}
                    <ListItemIcon>
                      <TimelapseIcon className="editIcons" />
                    </ListItemIcon>
                    <TextField
                      id="minutesTotal"
                      label={'Minutes'}
                      className="textField"
                      value={this.state.group.minutesTotal || ''}
                      onChange={this.handleChange('minutesTotal')}
                    />
                    {this.state.group.type !== 'one' && (
                      <FormControl className="textField">
                        <InputLabel htmlFor="color">Color</InputLabel>
                        <Select
                          value={this.state.group.color}
                          onChange={this.handleChange('color')}
                          inputProps={{
                            name: 'color',
                            id: 'color'
                          }}
                        >
                          <MenuItem value="" />
                          <MenuItem value={'rgba(147, 112, 219,0.6)'}>
                            <span style={{ color: 'rgba(147, 112, 219,0.6)' }}>
                              purple
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(100,149,237,0.3)'}>
                            <span style={{ color: 'rgba(100,149,237,0.3)' }}>
                              blue
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(0,191,255,0.4)'}>
                            <span style={{ color: 'rgba(0,191,255,0.4)' }}>
                              lightblue
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(32,178,170,0.6)'}>
                            <span style={{ color: 'rgba(32,178,170,0.6)' }}>
                              bluegreen
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(0,128,0,0.5)'}>
                            <span style={{ color: 'rgba(0,128,0,0.5)' }}>
                              green
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(144,238,144,0.6)'}>
                            <span style={{ color: 'rgba(144,238,144,0.6)' }}>
                              lightgreen
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(255,165,0,0.5)'}>
                            <span style={{ color: 'rgba(255,165,0,0.5)' }}>
                              orange
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(160,82,45,0.4)'}>
                            <span style={{ color: 'rgba(160,82,45,0.4)' }}>
                              brown
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(255,105,180,0.6)'}>
                            <span style={{ color: 'rgba(255,105,180,0.6)' }}>
                              pink
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(255,0,0,0.4)'}>
                            <span style={{ color: 'rgba(255,0,0,0.4)' }}>
                              red
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(128,128,128,0.4)'}>
                            <span style={{ color: 'rgba(128,128,128,0.4)' }}>
                              grey
                            </span>
                          </MenuItem>
                          <MenuItem value={'rgba(211,211,211,0.6)'}>
                            <span style={{ color: 'rgba(211,211,211,0.6)' }}>
                              lightgrey
                            </span>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </ListItem>

                  <ListItem className="modalContentSmallTime">
                    <ListItemIcon>
                      <DateRangeIcon className="editIconsSmall" />
                    </ListItemIcon>
                    <TextField
                      id="startedAt"
                      label={'Start'}
                      type="datetime-local"
                      defaultValue={moment(
                        new Date(this.state.group.startedAt)
                      ).format('YYYY-MM-DDTHH:mm')}
                      onChange={this.handleChange('startedAt')}
                      className="textFieldLong"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>
                  <ListItem className="modalContentSmallTime">
                    <ListItemIcon>
                      <AlarmOnIcon className="editIconsSmall" />
                    </ListItemIcon>
                    <TextField
                      id="completedAt"
                      label="End"
                      type="datetime-local"
                      value={moment(
                        new Date(this.state.group.completedAt)
                      ).format('YYYY-MM-DDTHH:mm')}
                      onChange={this.handleChange('completedAt')}
                      className="textFieldLong"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall',
                        step: 300 // 5 min
                      }}
                    />
                  </ListItem>
                  {this.state.group.type !== 'one' && (
                    <ListItem className="listItemSleepTimeComplete">
                      <FormGroup row style={{ paddingLeft: 30 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!this.state.group.isPublic}
                              onChange={this.handleChange('isPublic')}
                              value="isPublic"
                              style={{ color: 'lightblue' }}
                            />
                          }
                          label="Private"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={this.state.group.isDuration}
                              onChange={this.handleChange('isDuration')}
                              value="isDuration"
                              style={{ color: 'lightblue' }}
                            />
                          }
                          label="Duration"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              icon={<StarBorderIcon />}
                              checkedIcon={<StarIcon />}
                              checked={this.state.group.isStared}
                              onChange={this.handleChange('isStared')}
                              value="isStared"
                              style={{ color: 'lightblue' }}
                            />
                          }
                          label="Starred"
                        />
                      </FormGroup>
                    </ListItem>
                  )}
                </List>
                {!this.props.action.includes('add') &&
                  this.state.group.type !== 'one' && (
                    <GridList className="gridList" cols={4}>
                      {this.state.group.trackers &&
                        this.state.group.trackers.map((e, index) => (
                          <GridListTile
                            xs={6}
                            cols={1}
                            key={index}
                            style={{ height: 108 }}
                          >
                            <Paper
                              className="paperBlock"
                              style={{ borderRadius: 36 }}
                            >
                              <div
                                key={`bookblock-key-${index}`}
                                className="bookBlockChecked"
                                style={{
                                  backgroundColor: e.color
                                    ? e.color
                                    : 'lightgrey',
                                  opacity: 0.55
                                }}
                              >
                                <img
                                  alt=""
                                  className="iconTracker"
                                  src={
                                    process.env.PUBLIC_URL + '/cloud_done.png'
                                  }
                                />
                                <Typography
                                  variant="caption"
                                  style={{
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    textAlign: 'center',
                                    fontSize: 12,
                                    color: 'grey',
                                    lineHeight: 1.1
                                  }}
                                >
                                  {e.name}
                                </Typography>
                              </div>
                              <div
                                onClick={() => this.handleRemove(e.id)}
                                className="iconBtnEditSmallX"
                              >
                                {this.state.loading ? (
                                  <Loading />
                                ) : (
                                  <RemoveIcon
                                    style={{
                                      color: 'lightgrey',
                                      fontSize: 14
                                    }}
                                  />
                                )}
                              </div>
                            </Paper>
                          </GridListTile>
                        ))}
                      <GridListTile
                        xs={6}
                        cols={1}
                        key={'add'}
                        style={{ height: 90 }}
                      >
                        <Paper
                          className="paperBlock"
                          style={{ borderRadius: 36 }}
                          onClick={() => this.handleOpenTrackers()}
                        >
                          <div
                            key={`bookblock-key-add`}
                            className="bookBlockChecked"
                            style={{ backgroundColor: 'white' }}
                          >
                            <img
                              alt=""
                              className="iconTracker"
                              src={process.env.PUBLIC_URL + '/cloud_done.png'}
                            />
                            <Typography
                              variant="body1"
                              id="bookName"
                              style={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                textAlign: 'center',
                                fontSize: 12,
                                color: 'grey',
                                lineHeight: 1.1
                              }}
                            >
                              Add
                            </Typography>
                          </div>
                        </Paper>
                      </GridListTile>
                    </GridList>
                  )}
                <List>
                  <ListItem className="modalContentDone">
                    {this.props.action === 'edit' && (
                      <Button
                        onClick={this.handleOpenDelete}
                        className="iconBtnCheck"
                        size="small"
                      >
                        {' '}
                        <span style={{ color: 'grey', fontSize: 15 }}>
                          Delete
                        </span>
                      </Button>
                    )}
                    <ListItemText />
                    <Button
                      onClick={this.handleClose}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Cancel
                      </span>
                    </Button>
                    <Button
                      onClick={this.handleSave}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>Save</span>
                      {this.state.loadingSave ? (
                        <Loading />
                      ) : (
                        <ChevronRightIcon
                          style={{
                            color: 'grey',
                            fontSize: 20,
                            paddingLeft: 10
                          }}
                        />
                      )}
                    </Button>
                  </ListItem>
                </List>
              </div>
            )}
          </Paper>
        </Modal>
        <TrackersModal
          open={this.state.OpenTrackers}
          onClose={this.handleCloseTrackers}
          origin={'group'}
          id={this.state.group.id}
          trackers={this.state.group.trackers}
        />
        <DeleteModal
          open={this.state.OpenDelete}
          onClose={this.handleCloseDelete}
          yes={() => this.handleDelete(this.state.group.id)}
          loading={this.state.loadingDel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/GroupEdit.js